import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  selectTask,
  selectTasksLoading,
} from "../../../../redux/educator/selector";
import {
  approveTaskSubmit,
  getTaskById,
} from "../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  task: selectTask(state),
  users: selectTask(state)?.users,
  loading: selectTasksLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getTaskById,
      approveTaskSubmit,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
